module.exports = __webpack_public_path__ + "assets/img/2d.c0d90610.png";